<template>
  <section>
    <header>
      <h1 class="page-header">Change password</h1>
    </header>
    <errors-alert
      v-bind:errors="errorsFromBackend"
      v-on:clear="clearAlert()"
    />
    <form>
      <section class="form-group" v-bind:class="{ 'has-error': (submitAttempted && oldPasswordErrorMessage) }">
        <label class="control-label">
          Old password
          <input
            v-model="oldPassword"
            required
            type="text"
            class="form-control input-lg"
          >
        </label>
        <p v-if="submitAttempted && oldPasswordErrorMessage" class="help-block">
          {{ oldPasswordErrorMessage }}
        </p>
      </section>
      <section class="form-group" v-bind:class="{ 'has-error': (submitAttempted && newPasswordErrorMessage) }">
        <label class="control-label">
          New password
          <input
            v-model="newPassword"
            required
            type="text"
            class="form-control input-lg"
          >
        </label>
        <p class="help-block">
          Must be at least eight characters <span v-if="newPassword.length < 8">ℹ️</span><span v-else>✅</span>.
          <span v-on:click.prevent="xkcdVisible = !xkcdVisible" class="xkcd-toggle">
            Inspiration <span v-if="!xkcdVisible">▾</span><span v-else>▴</span>
          </span>
        </p>
        <p v-if="submitAttempted && newPasswordErrorMessage" class="help-block">
          {{ newPasswordErrorMessage }}
        </p>
      </section>
      <img v-if="xkcdVisible" src="/static/xkcd-password-strength.png">
      <button
        v-on:click.prevent="changePassword()"
        class="btn btn-primary btn-lg btn-block"
      >
        Change password
      </button>
    </form>
  </section>
</template>

<script>
import ErrorsAlert from '@/components/utilities/errors-alert';

export default {
  name: 'change-password',
  components: {
    'errors-alert': ErrorsAlert,
  },
  data: function () {
    return {
      oldPassword: '',
      newPassword: '',
      xkcdVisible: false,
      submitAttempted: false,
      errorsFromBackend: [],
    };
  },
  computed: {
    anyErrors: function () {
      return !!(this.oldPasswordErrorMessage || this.newPasswordErrorMessage);
    },
    oldPasswordErrorMessage: function () {
      if (this.oldPassword === '') {
        return 'A password is required';
      } else {
        return false;
      }
    },
    newPasswordErrorMessage: function () {
      if (this.newPassword === '') {
        return 'A password is required';
      } else if (this.newPassword.length < 8) {
        return 'Must be at least eight characters';
      } else {
        return false;
      }
    },
  },
  methods: {
    changePassword: function () {
      let self = this;

      if (self.anyErrors) {
        self.submitAttempted = true;
        return;
      }

      self.$http
        .patch(`${process.env.BASE_API_URL}/user/change-password`, {
          oldPassword: self.oldPassword,
          newPassword: self.newPassword,
        })
        .then(function (res) {
          self.$router.push({ path: '/' });
          alert('Successfully changed password.');
          localStorage.setItem('changedPasswordDate', new Date());
        })
        .catch(function (err) {
          self.errorsFromBackend.splice(0, self.errorsFromBackend.length);
          err.response.data.errors.forEach(function (errorFromBackend) {
            self.errorsFromBackend.push(errorFromBackend);
          });
        })
      ;
    },
    clearAlert: function () {
      this.errorsFromBackend.splice(0, this.errorsFromBackend.length);
    },
  },
};
</script>

<style lang="scss" scoped>
  section, input, button {
    font-size: 18px;
  }

  img {
    max-width: 100%;
    display: block;
    margin-bottom: 20px;
  }

  label {
    width: 100%;
  }

  .xkcd-toggle {
    cursor: pointer;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/change-password.vue